import React, { useState } from 'react'
import { Field, Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Box, Button, Container, Divider, FormControlLabel, Grid, TextField, Typography } from '@mui/material'
import { CheckboxComponent, TextFieldComponent } from '../../components/CustomFormElement'
import validators from '../../utils/validators';
import { makeStyles } from '@mui/styles';
import { Link } from 'react-router-dom';
import { paths } from '../../config/router.config';
import { EmailWhiteIcon, PasswordHideWhiteIcon, PasswordShowWhiteIcon, PhoneInputWhiteIcon } from '../../components/CustomIcons';
import theme from '../../theme.css';

const useStyles = makeStyles((theme) => ({
    content_link: {
        textAlign: 'center'
    },
    link:{
        textDecoration: 'none',
        color: theme.palette.text.link,
        cursor: 'pointer',
    },
    button: {
        textTransform: 'capitalize!important'
    },
    footer: {
        margin: theme.spacing(3, 0) + "!important",
    }
}));

export default function LoginView(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const {language, onForgotPassword, onSignUp} = props;
    const isEmailPass = true;
    const [isChangeIcon, setChangeIcon] = useState(false);
    const onChangeIconPass = ()=>{
        setChangeIcon(!isChangeIcon);
    }
    const goToMTN = () => {
        window.open(document._portalConfig.urlMTN, "_blank");
    }
    return (
        <Form
            onSubmit={props.onLogin}
            render={({ handleSubmit, reset, submitting, pristine, values }) => (
                <Grid xs={12} container item justify="center" alignItems="center">
                    <Grid xs={12} item style={{ textAlign: 'center', width: '100%'}}>
                        <Grid xs={12} item >
                            <Field
                                name="email"
                                component={TextFieldComponent}
                                placeholder={t('email_address')}
                                validate={validators.composeValidators(validators.validEmail)}
                            />
                        </Grid>
                        <Grid xs={12} item>
                            <Field
                                name="password"
                                component={TextFieldComponent}
                                placeholder={t('password')}
                                type={isChangeIcon ? 'text' : 'password'}
                                validate={validators.composeValidators(validators.required)}
                                endAdornment={<Grid style={{cursor: 'pointer'}} onClick={onChangeIconPass}>{ isChangeIcon ? <PasswordShowWhiteIcon/> : <PasswordHideWhiteIcon/>}</Grid>}
                            />
                        </Grid>
                        <Grid xs={12} item marginTop={3}>
                            <Box paddingTop={3} flex={1}>
                                <Button variant="contained" color="primary" fullWidth={true} onClick={handleSubmit} className={classes.button}>{t('btn_sign_in')}</Button>
                            </Box>
                        </Grid>
                        {/* <Grid xs={12} item marginTop={5}>
                            <Link to="/register" className={classes.link} fullWidth={true} onClick={onSignUp}>
                                {t('dont_accout_signup')}
                            </Link>
                        </Grid> */}
                    </Grid>
                    <Grid xs={12} item marginTop={3} marginBottom={3} className={classes.content_link}>
                        <Link to={paths.reset_password} className={classes.link} fullWidth={true}>
                            {t('forgot_password')}
                        </Link>                        
                    </Grid>
                    {document._portalConfig.urlMTN && <Grid item xs={12} marginTop={3} marginBottom={3} className={classes.content_link}>
                        <Typography variant='body1' color={theme.palette.text.disabled}>{t('MTN customers login ')}<span title={document._portalConfig.urlMTN} className={classes.link} onClick={() => goToMTN()}>{t("here.")}</span></Typography>
                    </Grid>}
                    <Grid item xs={12} marginBottom={3} className={classes.content_link}>
                        <Typography variant='body1' color={theme.palette.text.disabled}>
                            {t('Have not registered yet? ')}
                            <Link to={paths.register_existing} className={classes.link}>
                                {t("Register.")}
                            </Link>
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} className={classes.footer}>
                        <Footer t={t} classes={classes}/>
                    </Grid>
                </Grid>
            )} />
    )
}
function Footer(props){
    const {t, classes} = props;
    let currentYear = new Date().getFullYear();

    return (
        <Grid item xs={12} container direction='row'>
            <Grid item xs={6}>
                <Typography variant='body1' color={theme.palette.text.disabled}>{t('CRM.COM')}</Typography>
            </Grid>
            <Grid item xs={6} style={{textAlign: 'right'}}>
                <Typography variant='body1' color={theme.palette.text.disabled}>{t('© 2018-')}{currentYear}</Typography>
            </Grid>
        </Grid>
    );
}